import React from 'react';
import AsyncPage from './async';
import {Route} from 'react-router-dom';

export default [
  <Route
    key="/business/campaign/skincare-pro-skin-analysis"
    exact
    path="/business/campaign/skincare-pro-skin-analysis"
    component={AsyncPage}
  />,
];
